import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

export function TubelightNavbar({ items, className }) {
  const [activeTab, setActiveTab] = useState(items[0]?.name || '');

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -35% 0px',
      threshold: 0
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const item = items.find(item => item.url === `#${entry.target.id}`);
          if (item) {
            setActiveTab(item.name);
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    items.forEach((item) => {
      if (item.url.startsWith('#')) {
        const element = document.getElementById(item.url.substring(1));
        if (element) {
          observer.observe(element);
        }
      }
    });

    return () => observer.disconnect();
  }, [items]);

  return (
    <div
      className={cn(
        "fixed bottom-4 sm:bottom-auto sm:top-0 left-1/2 -translate-x-1/2 z-50 sm:pt-6 pointer-events-none w-full px-4 sm:px-0 sm:w-auto",
        className,
      )}
    >
      <div className="flex items-center justify-center gap-2 sm:gap-3 bg-black/80 backdrop-blur-2xl border border-white/20 py-3 sm:py-1 px-2 sm:px-1 rounded-full shadow-2xl shadow-primary/20 pointer-events-auto max-w-md sm:max-w-none mx-auto">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.name;

          return (
            <a
              key={item.name}
              href={item.url}
              onClick={(e) => {
                if (item.url.startsWith('#')) {
                  e.preventDefault();
                  const element = document.querySelector(item.url);
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }
                setActiveTab(item.name);
              }}
              className={cn(
                "relative cursor-pointer text-sm font-semibold px-4 sm:px-6 py-2.5 sm:py-2 rounded-full transition-all duration-300 flex items-center justify-center",
                "text-gray-400 hover:text-white",
                isActive && "bg-gradient-to-r from-primary/20 to-accent/20 text-white shadow-lg shadow-primary/30",
              )}
            >
              <span className="hidden md:inline">{item.name}</span>
              <span className="md:hidden flex items-center justify-center">
                <Icon size={20} strokeWidth={2.5} className={cn(
                  "transition-all duration-300",
                  isActive && "scale-110 text-primary"
                )} />
              </span>
              {isActive && (
                <motion.div
                  layoutId="lamp"
                  className="absolute inset-0 w-full bg-primary/10 rounded-full -z-10 border border-primary/30"
                  initial={false}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 30,
                  }}
                >
                  <div className="hidden sm:block absolute -top-2 left-1/2 -translate-x-1/2 w-8 h-1 bg-primary rounded-t-full">
                    <div className="absolute w-12 h-6 bg-primary/20 rounded-full blur-md -top-2 -left-2" />
                    <div className="absolute w-8 h-6 bg-primary/20 rounded-full blur-md -top-1" />
                    <div className="absolute w-4 h-4 bg-primary/20 rounded-full blur-sm top-0 left-2" />
                  </div>
                </motion.div>
              )}
            </a>
          );
        })}
      </div>
    </div>
  );
}
